import React from "react";
import ForgotPasswordConfirmation from "../auth/ForgotPasswordConfirmation";
import CommonAuthHeader from "./CommonAuthHeader";
import CommonHeader from "../CommonHeader";

const OptionsForgotPasswordConfirmation = () => {
  return (
    <>
      <CommonHeader icon="backArrow" navigation="/" />
      <CommonAuthHeader showSpeedLogo={false}>
        <ForgotPasswordConfirmation />
      </CommonAuthHeader>
    </>
  );
};

export default OptionsForgotPasswordConfirmation;
